import { Button, IconHelp, Typography } from '@screentone/core';
import classnames from 'classnames';

import styles from './HelpIcon.module.scss';

type WithText = { text: string; children?: never };
type WithChildren = { text?: never; children: React.ReactNode };

type HelpIconProps = (WithText | WithChildren) & {
  className?: string;
  isLeftAnchored?: boolean;
};

export const HelpIcon = ({ text, children, className, isLeftAnchored }: HelpIconProps) => (
  <div data-testid="help-icon-hover" className={classnames(styles.help, className)}>
    <Button data-testid="help-icon-icon" tertiary color="asphalt" icon={IconHelp} />
    <div
      data-testid="help-icon-container"
      className={classnames(styles.helpDropdown, isLeftAnchored ? styles.helpDropdownLeftAnchored : '')}
    >
      {children ?? (
        <Typography data-testid="help-icon-description" variant="note">
          {text}
        </Typography>
      )}
    </div>
  </div>
);
